module.exports = __webpack_public_path__ + "static/media/faq_image.b8c18936.png";